import { ParsedUrlQuery } from 'querystring';

import { useMemo, useState } from 'react';

import moment from 'moment';
import { useParams, useSearchParams } from 'next/navigation';

import { useSetSelectedVariations } from '@components/views/hotel/detail/context';
import { useSearchBarContext } from '@contexts/hotel/SearchBar';
import { WebUrlType } from '@api/v3';
import { paramsToObject } from '@components/views/utils';

import PackageResponsiveListingBox from './packageResponsiveListingBox';

export const PackageResponsiveSeachBar = ({
  detail,
  setShowFetchingAnimation,
  shouldResearchPackage,
  selectedTab,
  setSelectedTab,
  isAirportDateSelectionStarted,
  isAirportSelectionClicked,
  setIsAirportSelectionClicked,
  setisAirportDateSelectionStarted,
  setShouldResearchPackage,
  setIsRedirecting,
}: {
  detail?: boolean;
  setShowFetchingAnimation: (data: boolean) => void;
  shouldResearchPackage?: boolean;
  selectedTab?: string;
  setSelectedTab?: (string: any) => void;
  isAirportSelectionClicked?: boolean;
  setIsAirportSelectionClicked?: React.Dispatch<React.SetStateAction<boolean>>;
  isAirportDateSelectionStarted?: boolean;
  setisAirportDateSelectionStarted?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setShouldResearchPackage?: (data: boolean) => void;
  setIsRedirecting?: (data: boolean) => void;
}) => {
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);
  const params = useParams();

  const { in: startDate, out: endDate } = query;
  const {
    location,
    hotelRoomsList,
    setHotelDateSelection,
    isHotelDateSelected,
  } = useSearchBarContext();
  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const setSelectedVariations = useSetSelectedVariations();

  // ======================================
  // should shallow push if we the target page is hotel detail
  // ======================================
  const shouldShallowPush = useMemo(() => {
    return location?.type === WebUrlType.HOTEL;
  }, [location]);

  return (
    <PackageResponsiveListingBox
      setIsRedirecting={setIsRedirecting}
      shouldResearchPackage={shouldResearchPackage}
      detail={detail}
      suggestionLocation={String(params?.slug)}
      startDate={startDate ? moment(startDate) : null}
      endDate={endDate ? moment(endDate) : null}
      hotelRoomsList={hotelRoomsList}
      isModalVisible={showSearchModal || isHotelDateSelected}
      toggleIsModalVisible={() => setShowSearchModal((val) => !val)}
      shouldShallowPush={shouldShallowPush}
      hideModal={() => {
        setShowSearchModal(false);
        setHotelDateSelection(false);
      }}
      location={location}
      onResearchClick={() => {
        setShowFetchingAnimation(true);
        setSelectedVariations([]);
        setShouldResearchPackage?.(false);
      }}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      isAirportSelectionClicked={isAirportSelectionClicked}
      setIsAirportSelectionClicked={setIsAirportSelectionClicked}
      isAirportDateSelectionStarted={isAirportDateSelectionStarted}
      setisAirportDateSelectionStarted={setisAirportDateSelectionStarted}
      isHoliday={false}
    />
  );
};
